// Top-level sections of the Admin > Configuration page.
//
// Kept in its own module so the search index can map a result back to a section
// without importing the page component (which imports every section in turn).
export const menus = {
  globalSettings: 'Global Settings',
  fieldProperties: 'Field Properties',
  loanAction: 'Loan Actions',
  loanStatusRestrictions: 'Loan Status Restrictions',
  texts: 'Texts',
  emailSetup: 'Email Setup',
  rules: 'Rules',
  servicing: 'Servicing',
  links: 'Links',
  features: 'Quick Links',
  bubbles: 'Bubbles',
  exceptionRequests: 'Exceptions Requests',
  loanStatusLabel: 'Loan Status Label',
  interface: 'Interface',
  paymentTerms: 'Payment Terms and Conditions',
  hud1: 'Closing Configuration',
  footer: 'Footer',
  underwriting: 'Underwriting',
  servicingInformation: 'Servicing Information',
  formDefaults: 'Form Defaults',
  fee: 'Fee',
  hmda: 'HMDA',
  mlds: 'MLDS',
  mortgageCallReport: 'Mortgage Call Report',
  loanSubmissionHierarchy: 'Loan Submission Hierarchy',
  userSwitchVisibility: 'Switch User Visibility',
  orderValuation: 'Valuation Vendor',
  accountTypes: 'Manage Account Types',
  floaterTabs: 'Floater Tabs',
  secondaryMarketing: 'Secondary Marketing',
  counterParty: 'Counter Party',
  partyEligibility: 'Party Eligibility',
  creditReportDefaults: 'Credit Report Defaults',
  loanPipelineHeaders: 'Loan Pipeline Headers',
  tasks: 'Tasks',
  staticFiles: 'Static Files',
  documents: 'Documents',
  collateralReview: 'Collateral Review',
  borrowerPipelineAttentionTitles: 'Borrower Pipeline Attention Titles',
  loanOverviewAccess: 'Loan Overview Access',
  budgetTemplates: 'Budget Templates',
  hubspotSync: 'HubSpot Sync',
  printMail: 'Print & Mail',
}
